module.exports = __webpack_public_path__ + "img/12_42.61d27eff.png";